import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Structure from '../Structure';
import { Link, useParams } from 'react-router-dom';
import { Link as Enlace } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import data from '../../lib/backend/data';
import toast from 'react-hot-toast';
import { cerrarSesion } from '../../redux/actions/session';
import { siEsRequeridoEnEsquema } from '../../lib/helpers/main';
import CamposObligatoriosLeyenda from '../../subcomponents/general/formularios/campos_requeridos_leyenda';

const ClientesCreate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState({});
  const sesion = useSelector((state) => state.miusuario);
  const requeridos = [
    { value: 'nombre', label: 'Nombre' },
    { value: 'apellido', label: 'Apellido' },
    { value: 'email', label: 'Email' },
    { value: 'movil', label: 'Movil' },
    { value: 'pais_code', label: 'Codigo de País' },
    { value: 'sexo', label: 'Genero' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    clientes[name] = value;
    return setClientes({ ...{}, ...clientes });
  };

  const crearClientes = async () => {
    console.log(sesion);
    let faltantes = [];
    requeridos.map((campo) => {
      if (!clientes[campo.value]) faltantes.push(campo.label);
      return true;
    });
    if (faltantes.length > 0)
      return toast.error(`Faltan campos: ${faltantes.join(', ')}`);

    setLoading(true);
    return fetch(`${data.urlapi}/clientes`, {
      method: 'POST',
      body: JSON.stringify(clientes),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos');
          return setLoading(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoading(false);
        } else if (res._id) {
          toast.success('Creado exitosamente');
          setTimeout(() => {
            return (window.location = `/client-${res._id}`);
          }, 500);
        }
        return setLoading(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoading(false);
      });
  };

  const render = () => {
    return (
      <div>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link to='/clients'>Clientes</Link>
          <Enlace underline='hover' color='text.primary'>
            Crear Cliente
          </Enlace>
        </Breadcrumbs>
        <h1 style={{ margin: 0 }}>Crear Cliente</h1>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item md={12} xs={12}>
            <Typography variant='h6'>Datos</Typography>
            <CamposObligatoriosLeyenda />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              label='Nombre'
              variant='filled'
              name='nombre'
              required={siEsRequeridoEnEsquema("nombre",requeridos)}
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              label='Apellido'
              variant='filled'
              name='apellido'
              required={siEsRequeridoEnEsquema("apellido",requeridos)}
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              type='email'
              label='Email'
              variant='filled'
              name='email'
              required={siEsRequeridoEnEsquema("email",requeridos)}
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              label='Movíl'
              variant='filled'
              name='movil'
              required={siEsRequeridoEnEsquema("movil",requeridos)}
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <FormControl fullWidth className='mb-3'>
              <InputLabel id='demo-simple-select-label' required={siEsRequeridoEnEsquema("pais_code",requeridos)}>Codigo de País</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                label='Codigo de Pais *'
                name='pais_code'
                
                onChange={handleChange}
              >
                <MenuItem value='CL'>CL</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={3} xs={12}>
            <FormControl fullWidth className='mb-3'>
              <InputLabel id='demo-simple-select-label' required={siEsRequeridoEnEsquema("sexo",requeridos)}>Genero</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                label='Genero *'
                name='sexo'
                
                onChange={handleChange}
              >
                <MenuItem value='Masculino'>Masculino</MenuItem>
                <MenuItem value='Femenino'>Femenino</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12}>
            {loading === true ? (
              <CircularProgress />
            ) : (
              <Button
                variant='contained'
                xs={{ m: 0 }}
                onClick={() => crearClientes()}
              >
                CREAR
              </Button>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  return <Structure component={render()} />;
};

export default ClientesCreate;
